<template>
  <div v-if="isDirectoryPromotionBannerVisible" class="directory-banner">
    <h4 class="directory-banner__title">You might be interested in</h4>
    <div class="directory-banner__container">
      <ul slot="additional-info" class="directory-banner__categories">
        <li
          v-for="category in filteredCategories"
          :key="category.Id"
          class="directory-banner__category"
        >
          <a-link :to="`${$env.FM_DIR_DOMAIN_URL}/${category.Slug}`"
            >{{ category.Name }} ({{ category.CompaniesCount }})</a-link
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { propValidator, PROP_TYPES } from '@/utils/validators'

export default {
  name: 'DirectoryPromotionBanner',
  props: {
    categories: propValidator([PROP_TYPES.ARRAY])
  },
  computed: {
    filteredCategories() {
      return this.categories.filter(category => category.CompaniesCount)
    },
    isDirectoryPromotionBannerVisible() {
      return !!this.filteredCategories.length
    }
  }
}
</script>

<style lang="scss" scoped>
.directory-banner {
  margin-bottom: 30px;
  border-top: 2px solid $c--black;
  border-bottom: 2px solid $c--black;

  .directory-banner__container {
    position: relative;
    padding: 10px 0 60px 0;
    background-image: url('~assets/svg/icons-source/directory-promotion-banner.svg');
    background-size: cover;
  }

  .directory-banner__title,
  .directory-banner__category {
    font-weight: 600;
    padding-left: 20px;
    line-height: 43px;
  }

  .directory-banner__title {
    font-size: 19px;
    color: $c--white;
    background: $c--main;
    margin-bottom: 1px;
  }

  .directory-banner__categories {
    padding: 0 20px;
  }

  .directory-banner__category {
    line-height: 23px;
    border-bottom: 2px solid rgba($c--white, 0.5);
    font-size: 16px;
    position: relative;
    padding: 10px 0 10px 20px;

    &::before {
      content: '.';
      font-size: 40px;
      line-height: 0;
      position: absolute;
      top: 10px;
      left: 0;
    }

    &:last-child {
      border: none;
    }
  }
}
</style>
